import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e1d4aaa4")

_pushScopeId("data-v-e1d4aaa4")
const _hoisted_1 = { class: "remark" }
const _hoisted_2 = { class: "resize-handler" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "演讲者备注", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("span", null, _toDisplayString('(幻灯片 ' + (_ctx.slideIndex + 1) + '/' + _ctx.slides.length + ' )'), 1)
    ]),
    _createVNode("textarea", {
      value: _ctx.remark,
      placeholder: "点击输入演讲者备注",
      onInput: _cache[1] || (_cache[1] = $event => _ctx.handleInput($event))
    }, null, 40, ["value"])
  ]))
})